export const WIDGET_TYPE_TOP_LO_BAR_CHART = 'TOP_LO_BAR_CHART';
export const WIDGET_TYPE_TOP_ASSIGNMENTS_BAR_CHART =
  'TOP_ASSIGNMENTS_BAR_CHART';
export const WIDGET_TYPE_TOP_EXTERNAL_LO_BAR_CHART =
  'TOP_EXTERNAL_LO_BAR_CHART';
export const WIDGET_TYPE_LOGIN_PIE_CHART = 'LOGIN_PIE_CHART';
export const LOGIN_SLICE_NAMES = {
  LOGGED_IN: 'studentsHaveLoggedIn',
  NOT_LOGGED_IN: 'studentsHaveNotLoggedIn',
  LOGIN_DATA: 'loginData',
};
export const WIDGET_TYPE_ASSIGNMENT_SCORE_HISTOGRAM_CHART =
  'ASSIGNMENT_SCORE_HISTOGRAM_CHART';
export const WIDGET_TYPE_TIME_SCORE_CHART = 'WIDGET_TYPE_TIME_SCORE_CHART';
export const WIDGET_TYPE_TIME_ATTEMPTS_CHART =
  'WIDGET_TYPE_TIME_ATTEMPTS_CHART';
export const WIDGET_TYPE_COMPLETED_ASSIGNMENT =
  'WIDGET_TYPE_COMPLETED_ASSIGNMENT';
export const WIDGET_TYPE_SRL_CONFIDENCE_CHART = 'Confidence';
export const WIDGET_TYPE_SRL_GOAL_CHART = 'Student Goals';
export const WIDGET_TYPE_SRL_HOURS_CHART = 'Hours';
export const WIDGET_TYPE_SRL_GROWTH_CHART = 'Growth & Learning';
export const WIDGET_TYPE_SRL_CHALLENGES_CHART = 'Challenges';
export const WIDGET_TYPE_SRL_ACADEMICS_CHART = 'Academics';
export const WIDGET_TYPE_SRL_SPACING_PACING_CHART = 'Spacing & Pacing';
export const WIDGET_TYPE_SRL_CHALLENGE_AND_RECALL_CHART = 'Challenges & Recall';
export const WIDGET_TYPE_SRL_HELP_AND_COLLABORATION = 'Help and Collaboration';
export const WIDGET_TYPE_SRL_ENVIRONMENT_AND_MINDSET =
  'Environment and Mindset';
export const TIME_SCORE_HELPER_TEXT = 'Recommended for Assessments';
export const TIME_ATTEMPTS_HELPER_TEXT = 'Recommended for Adaptive Quizzes';

export const SRL_COMPONENT_TYPES = {
  ANSWER_CHANGE: 'Answer Change',
  AVERAGE: 'Average',
  BAR_CHART: 'Bar Chart',
  COLUMN_CHART: 'Column Chart',
  DIFFERENCE: 'Difference',
  MEDIAN: 'Median',
  MEDIAN_DIFFERENCE: 'Median Difference',
  PERCENTAGE: 'Percentage',
  STACKED_BAR_CHART: 'Stacked Bar Chart',
  TABLE: 'Table',
  TEXT_LIST: 'Text List',
};

export const INSIGHTS_MENU = {
  ASSIGNMENT_PERFORMANCE: 'Assignment Performance',
  COURSE_PERFORMANCE: 'Course Performance',
  GRS: 'Goal-setting and Reflection Responses',
};

export const isAssignmentPerfWidget = (widgetType) =>
  [
    WIDGET_TYPE_ASSIGNMENT_SCORE_HISTOGRAM_CHART,
    WIDGET_TYPE_TIME_SCORE_CHART,
    WIDGET_TYPE_TIME_ATTEMPTS_CHART,
    WIDGET_TYPE_COMPLETED_ASSIGNMENT,
  ].includes(widgetType);

export const isSRLWidget = (widgetType) =>
  [
    WIDGET_TYPE_SRL_CONFIDENCE_CHART,
    WIDGET_TYPE_SRL_GOAL_CHART,
    WIDGET_TYPE_SRL_HOURS_CHART,
    WIDGET_TYPE_SRL_GROWTH_CHART,
    WIDGET_TYPE_SRL_CHALLENGES_CHART,
    WIDGET_TYPE_SRL_ACADEMICS_CHART,
    WIDGET_TYPE_SRL_SPACING_PACING_CHART,
    WIDGET_TYPE_SRL_CHALLENGE_AND_RECALL_CHART,
    WIDGET_TYPE_SRL_HELP_AND_COLLABORATION,
    WIDGET_TYPE_SRL_ENVIRONMENT_AND_MINDSET,
  ].includes(widgetType);

export const isSRLWidgetSummarizable = (isIntroSurvey, widgetType) => {
  if (isIntroSurvey) {
    return [
      WIDGET_TYPE_SRL_CONFIDENCE_CHART,
      WIDGET_TYPE_SRL_GROWTH_CHART,
      WIDGET_TYPE_SRL_CHALLENGES_CHART,
      WIDGET_TYPE_SRL_ACADEMICS_CHART,
    ].includes(widgetType);
  } else {
    return [
      WIDGET_TYPE_SRL_GOAL_CHART,
      WIDGET_TYPE_SRL_GROWTH_CHART,
      WIDGET_TYPE_SRL_CHALLENGES_CHART,
    ].includes(widgetType);
  }
};

const isSRLIntroSurvey = true;
const isSRLEnglishVersion = true;
export const PX_PER_LETTER = 8;
export const SRL_DETAILS_TABLE = {
  [WIDGET_TYPE_SRL_CONFIDENCE_CHART]: {
    [isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 180,
      ROW_HEIGHT: 80,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      CONFIDENCE_COLUMN_IDX: 1,
      RESPONSES_COLUMN_IDX: 2,
      DEFAULT_SORT_INDEX: 1,
      SECONDARY_SORT_ORDER: [1, 0, 2],
      SCALING_COLUMN_COEFFICIENT: 2 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [0, 1],
      CENTER_ALIGNED_COLUMNS_INDICES: [1],
      WARNING_SCORE_COLUMNS_INDICES: [1], // DETERMINES WHICH COLUMNS CAN BE MARKED WITH HIGHLIGHTS
      CRITICAL_SCORE_VALUE: 1,
      LOW_SCORE_VALUE: 2,
      FIXED_COLUMNS_WIDTH_LIST: [250, 150],
      COLUMN_HEADER_ALIAS_LIST: [null, null, 'Explanations'],
      CUSTOM_EMPTY_FIELDS: [
        {
          COLUMN_INDEX: 2,
          DEFAULT_VALUE: 'No response',
        },
      ],
    },
    [!isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 220,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      CONFIDENCE_CURRENT_COLUMN_IDX: 1,
      CONFIDENCE_CHANGE_COLUMN_IDX: 2,
      DEFAULT_SORT_INDEX: 1,
      SECONDARY_SORT_ORDER: [1, 2, 0],
      SCALING_COLUMN_COEFFICIENT: 0 / 3, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [],
      CENTER_ALIGNED_COLUMNS_INDICES: [1, 2],
      WARNING_SCORE_COLUMNS_INDICES: [1, 2],
      CRITICAL_SCORE_VALUE: {
        // COLUMN_INDEX: CRITICAL_SCORE_VALUE
        1: 1,
        2: -2,
      },
      LOW_SCORE_VALUE: {
        1: 2,
        2: -1,
      },
    },
  },
  [WIDGET_TYPE_SRL_GOAL_CHART]: {
    [isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 120,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      DEFAULT_SORT_INDEX: 1,
      SECONDARY_SORT_ORDER: [1, 2, 0],
      DEFAULT_SORT_DIRECTION: 'desc',
      SCALING_COLUMN_COEFFICIENT: 0 / 3, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [],
      TEXT_ALIAS: {
        'I just want to pass': 'Pass',
      },
      CENTER_ALIGNED_COLUMNS_INDICES: [1, 2],
      WARNING_TEXT_COLUMNS_INDICES: [1, 2],
      CRITICAL_TEXT_VALUES: ['PASS', 'I JUST WANT TO PASS'],
      LOW_TEXT_VALUES: ['C'],
      GRADE_COLUMN_INDICES: [1, 2],
    },
    [!isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 160,
      ROW_HEIGHT: 80,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      RESPONSES_COLUMN_IDX: 3,
      DEFAULT_SORT_INDEX: 1,
      DEFAULT_SORT_DIRECTION: 'desc',
      SECONDARY_SORT_ORDER: [1, 2, 0, 3],
      SCALING_COLUMN_COEFFICIENT: 2 / 2, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [1, 2],
      CENTER_ALIGNED_COLUMNS_INDICES: [1, 2],
      WARNING_TEXT_COLUMNS_INDICES: [1],
      CRITICAL_TEXT_VALUES: ['NO'],
      HIGHLIGHT_TEXT_COLUMNS_INDICES: [2],
      HIGHLIGHT_TEXT_VALUES: ['NOW OFF TRACK'],
      CUSTOM_EMPTY_FIELDS: [
        {
          COLUMN_INDEX: 3,
          DEFAULT_VALUE: 'No response',
        },
      ],
      ALLOW_DISPLAY_EMPTY_COLUMNS_INDICES: [2],
    },
  },
  [WIDGET_TYPE_SRL_HOURS_CHART]: {
    [isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 120,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      DEFAULT_SORT_INDEX: 1,
      SECONDARY_SORT_ORDER: [1, 0],
      SCALING_COLUMN_COEFFICIENT: 0 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      TOTAL_HOURS_COLUMN_IDX: 1,
      HOURS_COLUMN_IDXS: [1],
      HOURS_HEADERS_WIDTH: [132],
      CENTER_ALIGNED_COLUMNS_INDICES: [1],
    },
    [!isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 120,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      DEFAULT_SORT_INDEX: 1,
      SECONDARY_SORT_ORDER: [1, 2, 0],
      SCALING_COLUMN_COEFFICIENT: 0 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [],
      TOTAL_HOURS_COLUMN_IDX: 1,
      HOURS_CHANGE_COLUMN_IDX: 2,
      HOURS_COLUMN_IDXS: [1, 2],
      HOURS_HEADERS_WIDTH: [132, 102], // headers width to allow create the effect of aligning the text right side, and  match with the right limit with the header
      CENTER_ALIGNED_COLUMNS_INDICES: [1, 2],
    },
  },
  [WIDGET_TYPE_SRL_GROWTH_CHART]: {
    [isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 280,
      ROW_HEIGHT: 80,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      REASON_COLUMN_IDX: 1,
      RESPONSES_COLUMN_IDX: 2,
      DEFAULT_SORT_INDEX: 1,
      SECONDARY_SORT_ORDER: [1, 0],
      SCALING_COLUMN_COEFFICIENT: 2 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [0, 1],
      CUSTOM_EMPTY_FIELDS: [
        {
          COLUMN_INDEX: 2,
          DEFAULT_VALUE: 'No response',
        },
      ],
    },
    [!isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 280,
      ROW_HEIGHT: 80,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      SECONDARY_SORT_ORDER: [0],
      SCALING_COLUMN_COEFFICIENT: 1 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      RESPONSES_COLUMN_IDX: 1,
      FIXED_WIDTH_COLUMN_INDICES: [0],
      CUSTOM_EMPTY_FIELDS: [
        {
          COLUMN_INDEX: 1,
          DEFAULT_VALUE: 'No response',
        },
      ],
    },
  },
  [WIDGET_TYPE_SRL_CHALLENGES_CHART]: {
    [isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 220,
      ROW_HEIGHT: 80,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      RESPONSES_COLUMN_IDX: 1,
      SECONDARY_SORT_ORDER: [0],
      SCALING_COLUMN_COEFFICIENT: 1 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [0],
      CUSTOM_EMPTY_FIELDS: [
        {
          COLUMN_INDEX: 1,
          DEFAULT_VALUE: 'No response',
        },
      ],
    },
    [!isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH_HE: 130,
      FIXED_COLUMN_WIDTH_HS: 220,
      ROW_HEIGHT: 130,
      HEADER_HEIGHT_ADJUSTMENT: 25,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      TALL_RESPONSES_COLUMN_IDX: 8,
      DEFAULT_SORT_DIRECTION: 'desc',
      SECONDARY_SORT_ORDER: [1, 2, 3, 4, 5, 6, 7, 0],
      WARNING_TEXT_COLUMNS_INDICES: [1, 2, 3, 4, 5, 6, 7],
      LOW_TEXT_VALUES: ['YES'],
      DEFAULT_SORT_INDEX: 0,
      CENTER_ALIGNED_COLUMNS_INDICES: null,
      POSITIVE_COLUMNS_TO_COUNT: [],
      FIXED_WIDTH_COLUMN_INDICES: [0, 1],
      FIXED_COLUMNS_WIDTH_LIST: [220, 240],
      TAGS_COLUMN_IDX: 1,
      RESPONSES_COLUMN_IDX: 2,
      RESPONSES_ANSWER_POSITION: 9,
      CUSTOM_EMPTY_FIELDS: [
        {
          COLUMN_INDEX: 1,
          DEFAULT_VALUE: 'No challenges',
        },
        {
          COLUMN_INDEX: 2,
          DEFAULT_VALUE: 'No response',
        },
      ],
    },
  },
  [WIDGET_TYPE_SRL_ACADEMICS_CHART]: {
    [isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 150,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      SECONDARY_SORT_ORDER: [0],
      SCALING_COLUMN_COEFFICIENT: 2 / 3, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [0, 1],
      RESPONSES_COLUMN_IDX: 4,
      ROW_HEIGHT: 80,
      FIXED_COLUMNS_WIDTH_LIST: [250],
      TEXT_ALIAS: {
        1: '1st year',
        2: '2nd year',
        3: '3rd year',
        4: '4th year',
        5: '5th year or later',
      },
      CUSTOM_EMPTY_FIELDS: [
        {
          COLUMN_INDEX: 4,
          DEFAULT_VALUE: 'No response',
        },
      ],
    },
    [!isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 280,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      DEFAULT_SORT_INDEX: 1,
      SECONDARY_SORT_ORDER: [1, 2, 0],
      SCALING_COLUMN_COEFFICIENT: 2 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [0],
      WARNING_TEXT_COLUMNS_INDICES: [1],
      CRITICAL_TEXT_VALUES: ['BELOW 60'],
      LOW_TEXT_VALUES: ['60 - 69'],
      HIGHLIGHT_TEXT_VALUES: ['1', '2'],
      HIGHLIGHT_TEXT_COLUMNS_INDICES: [2],
      CENTER_ALIGNED_COLUMNS_INDICES: [1, 2],
      WIDTH_ADJUSTMENT: {
        2: 250, // index column: width
      },
      TEXT_ALIAS: {
        1: '1 - Much lower than expected',
        2: '2 - Lower than expected',
        3: '3 - About what I expected',
        4: '4 - Higher than expected',
        5: '5 - Much higher than expected',
      },
      FULL_WIDTH_BY_CONTENT: {
        1: ['N/A - I did not receive a test score recently'],
      },
    },
  },
  [WIDGET_TYPE_SRL_SPACING_PACING_CHART]: {
    [isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 120,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      SECONDARY_SORT_ORDER: [0],
      SCALING_COLUMN_COEFFICIENT: 0 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      POSITIVE_COLUMNS_TO_COUNT: [1, 2, 3, 4, 5, 6, 7],
      HEADER_HEIGHT_ADJUSTMENT: 65, // allow 3 lines on header
      CENTER_ALIGNED_COLUMNS_INDICES: [1, 2, 3, 4, 5, 6, 7],
      FIXED_COLUMNS_WIDTH_LIST: [216],
    },
    [!isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 120,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      SECONDARY_SORT_ORDER: [0],
      SCALING_COLUMN_COEFFICIENT: 0 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [],
      FREQUENCY_COLUMN_INDICES: {
        [!isSRLEnglishVersion]: [2, 3, 4],
        [isSRLEnglishVersion]: [1, 2, 3, 4, 5],
      },
      CENTER_ALIGNED_COLUMNS_INDICES: [1, 2, 3, 4, 5, 6],
      HEADER_HEIGHT_ADJUSTMENT: 40, // allow 4 lines on header
      FREQUENCY_SUFFIX_INDICES: {
        [!isSRLEnglishVersion]: {
          INDICES: [1, 5],
          SUFFIX: {
            1: ['class', 'classes'],
            5: ['day', 'days'],
          },
        },
        [isSRLEnglishVersion]: {
          INDICES: [6],
          SUFFIX: {
            6: ['day', 'days'],
          },
        },
      },
    },
  },
  [WIDGET_TYPE_SRL_CHALLENGE_AND_RECALL_CHART]: {
    [isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 120,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      SECONDARY_SORT_ORDER: [0],
      SCALING_COLUMN_COEFFICIENT: 0 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [],
      POSITIVE_COLUMNS_TO_COUNT: [1, 2, 3, 4, 5, 6, 7],
      HEADER_HEIGHT_ADJUSTMENT: 55,
      CENTER_ALIGNED_COLUMNS_INDICES: [1, 2, 3, 4, 5, 6, 7],
    },
    [!isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 120,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      SECONDARY_SORT_ORDER: [0],
      SCALING_COLUMN_COEFFICIENT: 0 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [],
      FREQUENCY_COLUMN_INDICES: {
        [!isSRLEnglishVersion]: [1, 2, 3, 4, 5, 6],
        [isSRLEnglishVersion]: [1, 2, 3, 4],
      },
      CENTER_ALIGNED_COLUMNS_INDICES: [1, 2, 3, 4, 5, 6],
    },
  },
  [WIDGET_TYPE_SRL_HELP_AND_COLLABORATION]: {
    [isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 120,
      HEADER_HEIGHT_ADJUSTMENT: 50,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      SECONDARY_SORT_ORDER: [0],
      SCALING_COLUMN_COEFFICIENT: 0 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [],
      CENTER_ALIGNED_COLUMNS_INDICES: [1, 2, 3, 4, 5],
      POSITIVE_COLUMNS_TO_COUNT: [1, 2, 3, 4, 5],
    },
    [!isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 120,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      SECONDARY_SORT_ORDER: [0],
      SCALING_COLUMN_COEFFICIENT: 0 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [],
      CENTER_ALIGNED_COLUMNS_INDICES: [1, 2, 3, 4],
      WARNING_TEXT_COLUMNS_INDICES: [1, 2, 3, 4],
      CRITICAL_TEXT_VALUES: ['NEVER'],
      TEXT_ALIAS: {
        1: '1 time',
        2: '2 times',
        3: '3 or more times',
      },
    },
  },
  [WIDGET_TYPE_SRL_ENVIRONMENT_AND_MINDSET]: {
    [isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 120,
      HEADER_HEIGHT_ADJUSTMENT: 65,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      SECONDARY_SORT_ORDER: [0],
      SCALING_COLUMN_COEFFICIENT: 0 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [],
      CENTER_ALIGNED_COLUMNS_INDICES: [1, 2, 3, 4, 5, 6],
      POSITIVE_COLUMNS_TO_COUNT: [1, 2, 3, 4, 5, 6],
    },
    [!isSRLIntroSurvey]: {
      FIXED_COLUMN_WIDTH: 120,
      HEADER_HEIGHT_ADJUSTMENT: 65,
      HEADER_ROW_IDX: 0,
      NAME_COLUMN_IDX: 0,
      SECONDARY_SORT_ORDER: [0],
      SCALING_COLUMN_COEFFICIENT: 0 / 1, // FIXED WIDTH COLUMNS / GROWING COLUMNS
      FIXED_WIDTH_COLUMN_INDICES: [],
      CENTER_ALIGNED_COLUMNS_INDICES: [1, 2, 3, 4, 5, 6],
      WARNING_TEXT_COLUMNS_INDICES: [1, 2, 3, 4, 5, 6],
      CRITICAL_TEXT_VALUES: ['1'],
      LOW_TEXT_VALUES: ['2'],
      TEXT_ALIAS: {
        1: '1 - Never',
        2: '2 - Rarely',
        3: '3 - Sometimes',
        4: '4 - Often',
        5: '5 - Always',
      },
    },
  },
  SORT_ASCENDING: 'asc',
  SORT_DESCENDING: 'desc',
};

export const ASSIGNMENT_DETAILS_TABLE = {
  FIXED_COLUMN_WIDTH: 180,
  FIXED_WIDTH_COLUMN_INDICES: [2],
  CENTER_ALIGNED_COLUMNS_INDICES: [1],
  HEADER_ROW_IDX: 0,
  AVERAGES_ROW_IDX: 1,
  NAME_COLUMN_IDX: 0,
  SCORE_COLUMN_IDX: 1,
  WARNING_SCORE_COLUMNS_INDICES: [1],
  CRITICAL_SCORE_VALUE: 49,
  LOW_SCORE_VALUE: 70,
  TIME_COLUMN_IDX: 2,
  START_TS_COLUMN_IDX: 3,
  LATEST_TS_COLUMN_IDX: 4,
  DEFAULT_SORT_INDEX: 0,
  SECONDARY_SORT_ORDER: [0, 2, 3],
  FIXED_COLUMNS_WIDTH_LIST: [216],
  SCALING_COLUMN_COEFFICIENT: 1 / 4, // 1 FIXED WIDTH COLUMN / 4 GROWING COLUMNS
};

export const BRANDS = Object.freeze({
  HIGHER_ED: 'he',
  HIGH_SCHOOL: 'hs',
});

export const PERFORMANCE_BY_ASSIGNMENT_TOOLS = Object.freeze([
  'assessment',
  'learningcurve',
]);
